<template>
  <generic-content
      :isLinkable="false"
      :isEditable="isEditable"
      :isPayable="isPayable"
      :isDeletable="isDeletable"
      :isDownloadable="isDownloadable"
      :isViewable="isViewable"
      :is-selected="isSelected"
      @click="isParentMethodPriority?$emit('click'):downloadByDocument()"
      @download="downloadByDocument"
      @toRoute="isParentMethodPriority?$emit('toRoute'):''"
      @view="$emit('view')"
      @edit="$emit('edit')"
      @pay="$emit('pay')"
      @delete="$emit('delete')"
  >
    <template #bodyContent>
      <div class="d-flex justify-content-between h5">
        <div class="text-truncate">
          <!--          {{ vatDeclaration.employee._display }}-->
        </div>
      </div>
      <small class="d-flex justify-content-between">
        <div class="text-truncate">
          <i>{{ vatDeclaration.month|moment('MMMM YYYY')|capitalize }}</i>
        </div>
        <div>
          <!--          {{ currency(vatDeclaration.net) }}-->
        </div>
      </small>

    </template>

  </generic-content>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { currency } from '@/utils/filter'
import { downloadByDocument } from '../../../utils/utils'

import GenericContent from './Content'

export default {
  components: {
    GenericContent
  },
  props: {
    vatDeclaration: {
      type: Object,
      default: () => { }
    },
    isDownloadable: {
      type: Boolean,
      default: true
    },
    isViewable: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isPayable: {
      type: Boolean,
      default: false
    },
    isDeletable: {
      type: Boolean,
      default: true
    },
    isParentMethodPriority: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      currency,
      downloadByDocument,

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>